import { useQuery, useMutation } from '@tanstack/react-query'

import type { UseQueryResult, UseMutationResult } from '@tanstack/react-query'
import type { AxiosRequestConfig } from 'axios'
import type { IReportReviewMacro, IReviewReportMacroPayload } from '~/types/review'

import {
  createReviewReportMacro,
  deleteReviewReportMacro,
  getReviewsReportMacros,
  updateReviewReportMacro,
} from '~/api/reviews'

////////// KEYS //////////

export const keys = {
  all: ['reviews-report-macros'] as const,
  list: () => [...keys.all, 'listing'] as const,
}

////////// QUERIES //////////

export const useReviewsReportMacrosQuery = (
  params?: AxiosRequestConfig['params']
): UseQueryResult<IReportReviewMacro[]> => {
  return useQuery({
    queryFn: () => getReviewsReportMacros(params),
    queryKey: keys.list(),
  })
}

////////// MUTATIONS //////////

export const useCreateReviewReportMacroMutation = (): UseMutationResult<
  IReportReviewMacro,
  unknown,
  IReviewReportMacroPayload,
  unknown
> => {
  return useMutation({ mutationFn: createReviewReportMacro })
}

export const useDeleteReviewReportMacroMutation = (): UseMutationResult<
  void,
  unknown,
  { macroId: string },
  unknown
> => {
  return useMutation({ mutationFn: deleteReviewReportMacro })
}

export const useUpdateReviewReportMacroMutation = (): UseMutationResult<
  IReportReviewMacro,
  unknown,
  { macroId: string; payload: IReviewReportMacroPayload },
  unknown
> => {
  return useMutation({ mutationFn: updateReviewReportMacro })
}
